import React, { useState } from 'react'
import PropTypes from 'prop-types'
import lang from '@/lang'
import { makeStyles } from '@mui/styles'
import SVGIcon from '@/modules/base/components/svg-icon/svg-icon'
import Failed from '@assets/images/failed.svg'
import Finished from '@assets/images/successful.svg'
import CleverReachLoader from '@assets/images/transferCleverreach.svg?url'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import CheckIcon from '@assets/images/icons/check.svg'
import { Title } from '@/modules/base/components/texts'
import useWebSocketEvent, { EventTypes } from '@/modules/webSocket'
import { useNavigate } from 'react-router'

const { cleverreach: cleverreachLang } = lang

const STATES = {
  STARTED: 'started',
  FINISHED: 'finished',
  FAILED: 'failed',
}
const { STARTED, FINISHED, FAILED } = STATES

const WorkInProgress = (props) => {
  const navigate = useNavigate()
  const { onTransferFailed } = props
  const [progress, setProgress] = useState({ state: STARTED, subTitle: cleverreachLang.syncInProgressSubtitle, title: cleverreachLang.syncInProgressTitle })
  useWebSocketEvent(EventTypes.CLEVERREACH_SYNCHED, ({ data }) => {
    setProgress(data)
  })
  const classes = useStyles()

  const onButtonClick = () => {
    if (progress.state !== FAILED) {
      navigate('/dashboard')
    } else {
      onTransferFailed()
    }

  }

  return (
    <div className={classes.syncStartedWrapper}>
      {
        progress.state === STARTED
          ? <div className={classes.loader}>
            <div className={classes.spinner} />
            <div className={classes.loaderImageContainer}>
              <SVGIcon svg={CleverReachLoader} height='130px' width='130px' />
            </div>
          </div>
          : <div>
            <SVGIcon className={classes.transmittionFinished} svg={progress.state === FINISHED ? Finished : Failed} width='100px' height='100px' />
          </div>
      }
      <Title size='extraLarge' marginBottom='30px' position='center' fontWeight='mediumbold'>{ progress.title }</Title>
      <div className={classes.syncSubTitle}>{ progress.subTitle }</div>
      <ButtonIconSquare className={classes.dashboardButton} icon={CheckIcon} onClick={onButtonClick}>
        {progress.state !== FAILED ? cleverreachLang.buttonTextDashboard : cleverreachLang.buttonTextTryAgain}
      </ButtonIconSquare>
    </div>
  )
}

WorkInProgress.propTypes = {
  onTransferFailed: PropTypes.func.isRequired,
}

const useStyles = makeStyles(theme => ({
  syncStartedWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  loader: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    marginBottom: 38,
  },
  dashboardButton: {
    marginTop: 30,
    width: 200,
  },
  spinner: {
    width: 250,
    height: 250,
    borderRadius: '50%',
    border: `8px solid ${theme.primary}`,
    borderTop: `8px solid ${theme.primarySuperLight}`,
    borderRight: `8px solid ${theme.primarySuperLight}`,
    boxShadow: '0 0 10px rgba(0,0,0,0.16)',
    animation: 'spin 2s linear infinite',
  },
  '@keyframes spin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  loaderImageContainer: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    width: 234,
    height: 234,
    borderRadius: '50%',
    border: `1px solid ${theme.black}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  syncSubTitle: {
    lineHeight: '24px',
    letterSpacing: '0.16px',
  },
  transmittionFinished: {
    marginBottom: 40,
  },
}))

export default WorkInProgress
